module.exports = __webpack_public_path__ + "static/media/copy.f6afcd9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/copy.svg
// module id = 201
// module chunks = 0